import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { formatDateTime } from "../lib/format";

export default function AuditLog() {
    const [items, setItems] = useState([]);

    useEffect(() => {
        api.get("/audit-log").then((r) => setItems(r.data));
    }, []);

    return (
        <div className="space-y-5">
            <h1 className="font-display text-2xl sm:text-3xl font-bold text-slate-900">Audit Log</h1>
            <Card className="rounded-2xl border-slate-100">
                {items.length === 0 ? (
                    <div className="p-8 text-center text-sm text-slate-400">No activity yet</div>
                ) : (
                    <div className="divide-y divide-slate-100">
                        {items.map((i) => (
                            <div key={i.id} className="p-4 flex items-start justify-between gap-3" data-testid={`audit-row-${i.id}`}>
                                <div className="min-w-0">
                                    <div className="flex items-center gap-2 flex-wrap">
                                        <Badge className="bg-blue-50 text-blue-900 border-blue-100 hover:bg-blue-50 capitalize">
                                            {i.action}
                                        </Badge>
                                        <span className="text-sm font-semibold text-slate-900 capitalize">{i.entity}</span>
                                        <span className="text-xs text-slate-500 font-mono">{i.entity_id?.slice(0, 8)}…</span>
                                    </div>
                                    <div className="text-xs text-slate-500 mt-1">
                                        by <span className="font-semibold">{i.username}</span> · {formatDateTime(i.timestamp)}
                                    </div>
                                    {i.meta && Object.keys(i.meta).length > 0 && (
                                        <div className="text-xs text-slate-600 mt-1 font-mono bg-slate-50 px-2 py-1 rounded inline-block">
                                            {Object.entries(i.meta)
                                                .map(([k, v]) => `${k}: ${typeof v === "object" ? JSON.stringify(v) : v}`)
                                                .join(" · ")}
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </Card>
        </div>
    );
}
